import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loader',
});

const state = {
    outletList: [],
};

const getters = {
    outletList(state) {
        return state.outletList;
    },
    allowedOutletList(state, getters, rootState, rootGetters) {
        const isSuperAdmin = rootGetters[`Auth/hasSuperAdminRole`];

        if (!isSuperAdmin) {
            const allowedOutlets = rootGetters[`Auth/userOutlets`];
            return state.outletList.filter(o => allowedOutlets.includes(o.id));
        }

        return state.outletList;
    },
};

const mutations = {
    [types.SET_OUTLET_LIST](state, outlets) {
        state.outletList = outlets;
    },
};

const actions = {
    getOutletList({ commit, dispatch }) {
        const route = Laroute.route('data_api.all-outlet');
        startLoading(dispatch, 'fetch-outlet-list');

        return axios.get(route).then(res => {
            endLoading(dispatch, 'fetch-outlet-list');
            commit(types.SET_OUTLET_LIST, res.data);
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/outlet.js